import React from "react";

import { InfoSmIcon } from "@packages/ds";
import { useIntl } from "react-intl";

import { IconControl, Link } from "ds/Button";
import * as Dialog from "ds/Dialog";

import * as S from "./IntervalNotice.styles";

const IntervalNotice = () => {
  const intl = useIntl();

  return (
    <>
      <Dialog.Root>
        <Dialog.Trigger>
          <IconControl aria-label="info-trigger-interval-notice">
            <InfoSmIcon />
          </IconControl>
        </Dialog.Trigger>
        <Dialog.Content>
          <Dialog.Title>
            {intl.formatMessage({
              id: "backup_schedule.row.name.dialog.title",
              defaultMessage: "Backup scheduling"
            })}
          </Dialog.Title>
          <Dialog.Description>
            {intl.formatMessage({
              id: "backup_schedule.row.name.dialog.description",
              defaultMessage:
                "Backup intervals must be multiples of one another. E.g., if set at every 2 hrs, the next interval would be 4 or 6 hrs."
            })}
          </Dialog.Description>
          <Dialog.Title>
            {intl.formatMessage({
              id: "backup_schedule.row.name.dialog.example.title",
              defaultMessage: "Example:"
            })}
          </Dialog.Title>
          <Dialog.Description>
            <S.List>
              <li>
                {intl.formatMessage({
                  id: "backup_schedule.row.name.dialog.example.description.1",
                  defaultMessage: "2 hrs, 4 hrs, 8 hrs"
                })}
              </li>
              <li>
                {intl.formatMessage({
                  id: "backup_schedule.row.name.dialog.example.description.2",
                  defaultMessage: "1 day, 1 wk (7 days), 2 wks (14 days)"
                })}
              </li>
            </S.List>
          </Dialog.Description>
          <Dialog.Title>
            {intl.formatMessage({
              id: "backup_schedule.row.name.dialog.invalid.example.title",
              defaultMessage: "Invalid example:"
            })}
          </Dialog.Title>
          <Dialog.Description>
            <S.List>
              <li>
                {intl.formatMessage({
                  id: "backup_schedule.row.name.dialog.invalid.example.description.1",
                  defaultMessage: "2 hrs, 5 hrs, 8 hrs"
                })}
              </li>
              <li>
                {intl.formatMessage({
                  id: "backup_schedule.row.name.dialog.invalid.example.description.2",
                  defaultMessage: "3 days, 10 days, 2 wks (14 days)"
                })}
              </li>
            </S.List>
          </Dialog.Description>
          <Link
            analyticId="learnmore"
            href={intl.formatMessage({
              id: "links.documentation.environments.backup.multiple_automated_schedules"
            })}
          >
            {intl.formatMessage({ id: "learnmore" })}
          </Link>
        </Dialog.Content>
      </Dialog.Root>
      <S.IncrementNoticeLabel $color="neutral-600" textStyle="extraSmall">
        {intl.formatMessage({
          id: "backup_schedule.row.name.error",
          defaultMessage: "Intervals must be a multiple of one another"
        })}
      </S.IncrementNoticeLabel>
    </>
  );
};

export default IntervalNotice;
